<mat-card appCard class="table-card">
    <mat-card-content>
        <table
                [dataSource]="dataSource"
                class="mat-elevation-z8 table-card"
                mat-table
                style="width: 100%"
        >
            <ng-container
                    *ngFor="let column of readColumns; let i = index; first as first"
                    [matColumnDef]="column"
            >
                <th
                        *matHeaderCellDef
                        mat-header-cell
                        style="text-align: center; font-size: 17px"
                >
                    {{ labels[column] | translate }}
                </th>

                <td *matCellDef="let type" mat-cell style="text-align: center">
                    {{ type[column] | typedValue | async | translate }}
                </td>
            </ng-container>


            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        </table>

        <app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

    </mat-card-content>
</mat-card>
